var render, staticRenderFns
import script from "./AgeBadge.vue?vue&type=script&lang=js"
export * from "./AgeBadge.vue?vue&type=script&lang=js"
import style0 from "./AgeBadge.vue?vue&type=style&index=0&id=785309dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports